import React from "react";

import "../../assets/css/mission-list.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import MissionListDashboard from "../../components/mission/MissionListDashboard";

const MissionList = () => {
  return (
    <div className="main">
      <NavBar userType="interim" />
      <MissionListDashboard mode="particulier" />
      {/*<MissionListDashboard mode="particulier"/>*/}
    </div>
  );
};

export default MissionList;
